import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { API } from '../config'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'

const Login = () => {

    const [userId , setUserId] = useState()
    const [password, setPassword] = useState()

    let aimsAdminToken = localStorage.getItem("aimsAdminToken");


    const navigate = useNavigate()

    useEffect(()=>{
        if(aimsAdminToken){
            navigate('/')
        }
    },[aimsAdminToken])

    const handellogin = () =>{
        if(userId !== "" && userId !== undefined && password !== undefined && password !== ""){
            axios.post(`${API}?action=login&format=new`,{email: userId, password: password})
            .then((res)=>{
                if(res?.data?.status){ 
                    Swal.fire({
                        title: "",
                        text: (res?.data?.msg),
                        icon: "success"
                      });
                      localStorage.setItem("aimsAdminToken", res?.data?.token);
                      navigate('/')
                }
                else{
                    Swal.fire({
                        title: "",
                        text: (res?.data?.msg),
                        icon: "error"
                      });
                }
            })
            .catch((err)=>{
                console.log(err);
            })
        }else{
            Swal.fire({
                title: "",
                text: "All Filds are required",
                icon: "error"
              });
        }
    }
    return (
        <div style={{ height: '80vh', width: '100%' }} class='d-flex align-items-center justify-content-center'>
            <div class='col-lg-6 col-11 bg-white rounded-4'>
                <br />
                <div class='col-11 m-auto text-start'>
                    <p class='fw-semibold fs-2'> Log-in</p> 
                    <input type="text" class='form-control mt-3' placeholder='User Id' value={userId} onChange={(e)=>setUserId(e?.target?.value)} />
                    <input type="text" class='form-control mt-3' placeholder='Password' value={password} onChange={(e)=>setPassword(e?.target?.value)} />
                    <button class='btn btn-outline-primary mt-3' onClick={handellogin} >Log-in</button>
                </div>
                <br />


            </div>
        </div>
    )
}

export default Login